// extracted by mini-css-extract-plugin
module.exports = {"title":"SearchFootnote-module_title_30ejz","description":"SearchFootnote-module_description_32nHE"};